module.exports = __webpack_public_path__ + "img/image01.92fc238c.jpg";